import React from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { useTranslation } from 'react-i18next'

import { ExpandableBlocks, ContentBlock } from 'components/ContentBlock'
import { Form, Select, DateTimePicker, WeekdayPicker, Checkbox } from 'components/forms'
import { useQuery } from 'components/graphql'
import queryPriceLevels from 'config/localServer/query/priceLevelsQuery'
import Divider from 'components/Divider'

const General = ({ initialValues, onSubmit }) => {
	const [t] = useTranslation()

	const { data, queryField } = useQuery(queryPriceLevels)
	const priceLevelsOptions = data?.[queryField]?.map?.((item, i) => ({ value: i + 1, label: item })) || []
	priceLevelsOptions.unshift({ value: 0, label: t('options_section.strings.standard_price') })

	const priceLevelForm = initialValues?.parameters?.priceLevelForm || []
	const fields = priceLevelForm.map((item, i) => (
		<div key={i}>
			{i !== 0 && <Divider visible inverted />}
			<Row>
				<Col xs>
					<DateTimePicker
						field={`parameters.priceLevelForm[${i}].timeInterval`}
						label={{ from: t('common.fields.from_time'), to: t('common.fields.to_time') }}
						picker='time'
						interval
						addDateToTime={false}
					/>
					<WeekdayPicker field={`parameters.priceLevelForm[${i}].weekDays`} />
				</Col>
				<Col xs>
					<Select
						field={`parameters.priceLevelForm[${i}].priceLevel.normal`}
						label={t('options_section.fields.normal')}
						options={priceLevelsOptions}
					/>
					<Select
						field={`parameters.priceLevelForm[${i}].priceLevel.inCafe`}
						label={t('options_section.fields.inCafe')}
						options={priceLevelsOptions}
					/>
				</Col>
			</Row>
		</div>
	))

	return(
		<ExpandableBlocks nested>
			<ContentBlock label={t('options_section.strings.time_related_prices')} startExpanded>
				<Form
					initialValues={initialValues}
					onSubmit={onSubmit}
					smartSubmit
				>
					{fields}
				</Form>
			</ContentBlock>
			<ContentBlock label={t('options_section.strings.in_the_house')}>
				<Form
					initialValues={initialValues}
					onSubmit={onSubmit}
					smartSubmit
				>
					<Row>
						<Col xs>
							<Checkbox
								field='parameters.isInCafeMode'
								label={t('options_section.fields.activate_the_house')}
							/>
							<Checkbox
								field='parameters.isInCafeModeDefault'
								label={t('options_section.fields.in_cafe_prices_default')}
							/>
						</Col>
					</Row>
				</Form>
			</ContentBlock>
		</ExpandableBlocks>
	)
}

export default General
